<template>
    <div>
        <el-form ref="loginForm" :model="form" :rules="rules" label-width="80px" class="login-box">
            <h3 class="login-title">欢迎登录</h3>
            <el-form-item label="账号" prop="account">
                <el-input type="text" placeholder="请输入账号" v-model="form.account"/>
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input type="password" placeholder="请输入密码" v-model="form.password"/>
            </el-form-item>
            <el-form-item label="验证码"  prop="verifyCode">
                <!-- 注意：prop与input绑定的值一定要一致，否则验证规则中的value会报undefined，因为value即为绑定的input输入值 -->
                <el-input placeholder="请输入验证码" class="identifyinput" v-model="form.verifyCode" />
            </el-form-item>
            <el-form-item>
                <div class="identifybox">
                    <el-row type="flex" justify="space-between">
                    <el-col :span="11">
                        <div @click="refreshCode">
                            <img :src="imgURL"  />
                        </div>
                    </el-col>
                    <el-col :span="11" >
                        <el-button @click="refreshCode" type='text' class="textbtn">看不清，换一张</el-button>
                    </el-col>
                    </el-row>
                </div>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit('loginForm')">登录</el-button>
                <el-button type="text" @click="restPWD">忘记密码？</el-button>
            </el-form-item>
        </el-form>

        <el-dialog
                title="温馨提示"
                :visible.sync="dialogVisible"
                :close-on-click-modal=false
                width="30%"
                >
            <span>请输入账号和密码</span>n
            <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
        </el-dialog>

    </div>
</template>

<script>
    import https from '@/https.js'
    import VerificationCode from '@/components/VerificationCode.vue'

    export default {
        name: "Login",
        components: {
            VerificationCode
        },
        data() {
            return {
                imgURL: '',
                form: {
                    account: '',
                    password: '',
                    verifyCode:'',
                    VCode: '123',
                },
                // 表单验证，需要在 el-form-item 元素中增加 prop 属性
                rules: {
                    account: [
                        {required: true, message: '账号不可为空', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '密码不可为空', trigger: 'blur'}
                    ],
                    verifyCode: [
                        {required: true, message: '验证码不可为空', trigger: 'blur'}
                    ]
                },

                // 对话框显示和隐藏
                dialogVisible: false
            }
        },
        methods: {
            //获取本部机构号
            getEblcu() {
              ///ssoLogin/getEblcu
              https.fetchGet("ssoLogin/getEblcu" ,"" ,"").then((data) => {
                let code = data.data.code;
                let msg = data.data.msg;
                if(code == '200') {                 
                   this.$store.commit("setEblcuOrg",data.data.data);
                }
              }).catch(err=>{
                    console.log(err)
                  }
              )
            },
          selectMenu() {
            let params = {
              appId: "manager"
            };
            this.https.fetchPost('/managerPermission/selectMenuTree', params).then((data) => {
              let code = data.data.code;
              if (code == '200') {
                let menus = data.data.data
                for(let menu of menus) {
                  if(menu.children && menu.children.length > 0) {
                    for(let m of menu.children) {
                      if(m.children && m.children.length > 0) {
                        this.$router.push(m.children[0].url);
                        return;
                      }else {
                        this.$router.push(m.url);
                        return;
                      }
                    }
                  }
                }
              }
            }).catch(err => {
              console.log(err)
            })
          },
            onSubmit(formName) {
                // 为表单绑定验证功能
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let params = this.form;
                        let header = [];
                        let VCode = {
                            key: 'VCode',
                            value: this.form.VCode
                        }
                        header.push(VCode);
                        https.fetchPost('/ssoLogin/login',params ,"json",header).then((data) => {
                            let code = data.data.code;
                            let msg = data.data.msg;
                            if(code == '200') {
                                if(data.data.data.user.userModel==null || data.data.data.user.userModel==1){
                                    this.$message({
                                        type: 'info',
                                        message: '无权限登录'
                                    });
                                }else{
                                    this.$store.commit("setIsLogin","1");
                                    this.$store.commit("setOrgCode",data.data.data.orgCode);
                                    this.$store.commit("seOrgType",data.data.data.orgType);
                                    this.$store.commit("setUser",data.data.data.user);
                                    this.$store.commit("setToken",data.data.data.token);
                                    this.getEblcu();
                                    this.selectMenu();
                                }

                            } else {
                                this.$message({
                                    type: 'info',
                                    message: '登录失败:'+msg
                                });
                            }
                        }).catch(err=>{
                                console.log(err)
                            }
                        )

                    } else {
                        this.dialogVisible = true;
                        return false;
                    }
                });
            },
            refreshCode() {
                https.fetchGet("/ssoLogin/getCode" ,"" ,"blob").then((data) => {
                    let file = window.URL.createObjectURL(data.data);
                    this.imgURL = file;
                    this.form.VCode = data.headers.vcode;
                }).catch(err=>{
                        console.log(err)
                    }
                )
            },
            restPWD() {
              let url = https.findPwd;
              window.open(url, '_blank');
            }
        },

        mounted() {
            this.refreshCode();
        }
    }
</script>

<style scoped>
    .login-box {
        border: 1px solid #DCDFE6;
        width: 400px;
        margin: 80px auto;
        padding: 35px 35px 15px 35px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        box-shadow: 0 0 25px #909399;
    }

    .login-title {
        text-align: center;
        margin: 0 auto 40px auto;
        color: #303133;
    }
</style>
